import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {apiGet} from '../../../axiosConfig';
import {IApiDataResponse} from '../../../dto/API.dto';
import {IDataProps} from '../../../dto/Message.dto';

export const useRqGetRecordingVerificationTaskMessages = (taskId: number) => {
  return useQuery({
    queryKey: [getRecordingVerificationTaskMessagesUrl(taskId)],
    queryFn: () => getRecordingVerificationTaskMessages(taskId),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
const getRecordingVerificationTaskMessages = (taskId: number) => {
  return apiGet(getRecordingVerificationTaskMessagesUrl(taskId)).then(
    (response: AxiosResponse<IApiDataResponse<IDataProps>>) => {
      return response.data.data;
    },
  );
};
export const getRecordingVerificationTaskMessagesUrl = (taskId: number) => {
  return `v1/task/${taskId}/recording-verification`;
};
